/**
 * 키오스크 설정
 */

/** 미입력 시 자동 초기화 타임아웃 (밀리초) */
export const IDLE_TIMEOUT_MS = 60_000;

/** 완료 화면 자동 복귀 시간 (초) */
export const AUTO_RETURN_SECONDS = 10;

/**
 * 매장 식별자 타입
 */
export interface StoreIdentifier {
  type: 'id' | 'shortCode';
  value: string;
}

/**
 * storeId 또는 shortCode 조회
 * 1순위: URL 쿼리 파라미터 ?storeId=xxx
 * 2순위: URL 경로 패턴 /s/:shortCode
 * 3순위: URL 경로 패턴 /매장ID (UUID 형태)
 * 4순위: 환경변수 REACT_APP_STORE_ID
 */
export function getStoreIdentifier(): StoreIdentifier {
  // 1순위: URL 쿼리 파라미터 ?storeId=xxx
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get('storeId');
  if (fromUrl) {
    return { type: 'id', value: fromUrl };
  }

  // 2순위: URL 경로 패턴 /s/:shortCode
  const shortCodeMatch = window.location.pathname.match(
    /^\/s\/([A-Za-z0-9]{1,10})\/?$/
  );
  if (shortCodeMatch) {
    return { type: 'shortCode', value: shortCodeMatch[1].toUpperCase() };
  }

  // 3순위: URL 경로 패턴 /매장ID (UUID 형태)
  const pathMatch = window.location.pathname.match(
    /^\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i
  );
  if (pathMatch) {
    return { type: 'id', value: pathMatch[1] };
  }

  // 4순위: 환경변수 REACT_APP_STORE_ID
  const fromEnv = process.env.REACT_APP_STORE_ID;
  if (fromEnv) {
    return { type: 'id', value: fromEnv };
  }

  throw new Error('storeId가 설정되지 않았습니다. URL ?storeId=xxx 또는 /s/숏코드 또는 REACT_APP_STORE_ID 환경변수를 설정하세요.');
}

/**
 * storeId 조회 (기존 호환성 유지)
 * shortCode인 경우 API를 호출하여 storeId로 변환 필요
 */
export function getStoreId(): string {
  const identifier = getStoreIdentifier();
  if (identifier.type === 'id') {
    return identifier.value;
  }
  // shortCode인 경우 직접 storeId를 반환할 수 없으므로 에러
  // App.tsx에서 비동기로 처리해야 함
  throw new Error('SHORT_CODE:' + identifier.value);
}

/**
 * API 기본 URL 조회
 * 환경변수 REACT_APP_API_URL 또는 빈 문자열 (동일 도메인)
 */
export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL ?? '';
}
